import { ParlayTicketModel, TicketModel } from '@/hooks/query';
import { QuickStake } from '../quick-stake';
import { QuickStakeMini } from '../quick-stake-mini';
import { useBetslipStore } from '@/store/betslip';
import { BackspaceIcon } from '@/components/icons/svg-icons';
import { bettingInputMaxLength } from '@/hooks/query';
import { useTranslations } from 'next-intl';
import { useBetslipContext } from '@/features/betslip/contexts/betslip-context';
import { useAsideBetslip } from '@/features/betslip/hook/use-aside-betslip';
import { useFloatBetslip } from '@/features/betslip/hook/use-float-betslip';


interface BetKeypadProps {
	isExpand: boolean;
	isParlay: boolean;
	ticketKey: string;
	ticketStake: number;
	ticketMaxBet: number;
}

export const BetKeypad = ({
	isExpand,
	isParlay,
	ticketKey,
	ticketStake,
	ticketMaxBet
}: BetKeypadProps) => {

	const { oddsType } = useBetslipContext();
	const t = useTranslations('General');

	const [
		focusOddsKey,
		setFocusOddsKey,
		selectAllOddsKey,
		setSelectAllOddsKey,
		getTicketByKey,
		updateTicket,
		betslipType,
		useSabaCoin,
		setMultiStakePerBet,
		setParlayStakePerBet
	] = useBetslipStore(state => [
		state.focusOddsKey,
		state.setFocusOddsKey,
		state.selectAllOddsKey,
		state.setSelectAllOddsKey,
		state.getTicketByKey,
		state.updateTicket,
		state.betslipType,
		state.useSabaCoin,
		state.setMultiStakePerBet,
		state.setParlayStakePerBet
	]);
	const { activeAsideBetSlip } = useAsideBetslip();
	const { activeFloatBetSlip } = useFloatBetslip();

	const isSingleBetMode = betslipType === 'single' && !activeAsideBetSlip && !activeFloatBetSlip;;
	const isSelectAll = selectAllOddsKey === ticketKey;

	const getCssClassName = () => {
		let name = '';
		if (isSingleBetMode) {
			name = 'bet-slip__keypad';
		} else if (isParlay && isExpand) {
			name = 'bet-slip-parlay__keypad';
		} else {
			name = 'ticket__keypad';
		}
		return name;
	}

	const resetStakePerBet = (ticket: TicketModel | ParlayTicketModel) => {
		if (isParlay) {
			if ((ticket as ParlayTicketModel).isComboParlay) {
				setParlayStakePerBet(0);
			}
		} else {
			setMultiStakePerBet(0);
		}
	}

	const onNumberPress = (value: string) => {
		let stake = (ticketStake ?? 0).toString();

		if (stake.length >= bettingInputMaxLength || isSelectAll) {
			stake = value
		} else {
			stake = stake + value;
		}

		const ticket = getTicketByKey(ticketKey, isParlay);
		const newTicket = { ...ticket, stake: Number(stake) };

		setSelectAllOddsKey('');
		resetStakePerBet(newTicket as TicketModel | ParlayTicketModel);
		updateTicket(newTicket as TicketModel | ParlayTicketModel, isParlay, oddsType);
	}

	const onBackspacePress = () => {
		let stake = (ticketStake ?? 0).toString();

		if (isSelectAll) {
			stake = '0';
		} else {
			stake = stake.substring(0, stake.length - 1);
		}

		const ticket = getTicketByKey(ticketKey, isParlay);
		const newTicket = { ...ticket, stake: Number(stake) };


		setSelectAllOddsKey('');
		resetStakePerBet(newTicket as TicketModel | ParlayTicketModel);
		updateTicket(newTicket as TicketModel | ParlayTicketModel, isParlay, oddsType);
	}

	const onDonePress = () => {
		setFocusOddsKey('')
		setSelectAllOddsKey('');
	}

	let keypadClassName = 'keypad--quickstake-mini';
	if (useSabaCoin) {
		keypadClassName = 'keypad--default-mini';
	}

	return (
		<div
			className={getCssClassName()}
			data-show={ticketKey === focusOddsKey}
		>
			{
				!isSingleBetMode ?
					<QuickStake
						isParlay={isParlay}
						ticketKey={ticketKey}
						ticketStake={ticketStake}
						ticketMaxBet={ticketMaxBet}
					/> : null
			}
			<div className={`keypad ${keypadClassName}`}>
				<div className="keypad__numbers">
					<div className="keypad-btn" onClick={() => onNumberPress('1')}>1</div>
					<div className="keypad-btn" onClick={() => onNumberPress('2')}>2</div>
					<div className="keypad-btn" onClick={() => onNumberPress('3')}>3</div>
					<div className="keypad-btn" onClick={() => onNumberPress('4')}>4</div>
					<div className="keypad-btn" onClick={() => onNumberPress('5')}>5</div>
					<div className="keypad-btn" onClick={() => onNumberPress('6')}>6</div>
					<div className="keypad-btn" onClick={() => onNumberPress('7')}>7</div>
					<div className="keypad-btn" onClick={() => onNumberPress('8')}>8</div>
					<div className="keypad-btn" onClick={() => onNumberPress('9')}>9</div>
					<div className="keypad-btn" onClick={() => onNumberPress('0')}>0</div>
					<div className="keypad-btn" onClick={() => onNumberPress('00')}>00</div>
					<div className="keypad__backspace" onClick={onBackspacePress}>
						<div className="keypad-btn">
							<BackspaceIcon />
						</div>
					</div>
				</div>
				
				{!useSabaCoin ? (
					<QuickStakeMini
						isParlay={isParlay}
						ticketKey={ticketKey}
						ticketMaxBet={ticketMaxBet}
						isShowMax={false}
					/>
				) : null}
				
				<div className="keypad__submit" onClick={onDonePress}>
					<div className="keypad-btn">{t('lbl_Done')}</div>
				</div>
			</div>
		</div>
	);
};